module.exports = __webpack_public_path__ + "static/media/sy.b9b0ad4e.png";